<script setup lang="ts">
import type { NovaButtonSupportProps } from './NovaButtonSupport.types'

withDefaults(defineProps<NovaButtonSupportProps>(), {
  disabled: false,
})
</script>

<template>
  <button type="button" class="project-support-btn" :disabled="disabled">
    <span class="label">{{ label }}</span>
  </button>
</template>

<style lang="scss" scoped>
.project-support-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 112px;
  height: 32px;
  background: #ffed00;
  border: 2px solid #ffed00;
  overflow: hidden;
  border-radius: $radius-10;

  &:disabled {
    &:after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: '';
      background-color: hex-to-rgba($color-black, 0.6);
    }
  }

  .label {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 5px;
    @include text-style($text-body-14-bold);
    line-height: 1;
    text-shadow: 1px 1px 1px #fff;
    color: $color-black;
    border: 2px solid rgba(0, 0, 0, 0.6);
    border-radius: 14px;
  }

  @include mobile {
    width: 81px;
    height: 26px;
    border-radius: 13px;

    .label {
      @include text-style($text-body-12-bold);
      border-radius: 12px;
    }
  }
}
</style>
